module.exports = __webpack_public_path__ + "static/media/arrow-circle-right.0fde6466.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/developing/arrow-circle-right.svg
// module id = 1941
// module chunks = 1